
import React from 'react';

interface ConfirmationCheckboxProps {
  confirmed: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
}

const ConfirmationCheckbox = ({ confirmed, onConfirmedChange }: ConfirmationCheckboxProps) => {
  return (
    <div className="bg-gray-900 border border-gray-700 p-6 rounded-lg">
      <label className="flex items-start space-x-3 cursor-pointer">
        <input
          type="checkbox"
          checked={confirmed}
          onChange={(e) => onConfirmedChange(e.target.checked)}
          className="mt-1 h-4 w-4 text-sports-green bg-gray-800 border-gray-600 rounded focus:ring-sports-green"
        />
        <div className="text-white">
          <p className="font-semibold">I have safely stored all my account information</p>
          <p className="text-sm text-gray-400 mt-1">
            I understand this includes my username, password, PIN, and recovery phrase. This is the only time I'll see my password in plain text.
          </p>
        </div>
      </label>
    </div>
  );
};

export default ConfirmationCheckbox;
